export default __webpack_public_path__ + "static/media/product-2-min.0ef21c35.jpg";